<template>
    <router-link
            class="venue__list_grid_item"
            :to="{ name: 'ebs-venue-show', params: { id: venueId } }"
    >
        <div class="columns">
            <div class="column is-narrow">
                <div class="venue__list_grid_item_image">
                    <template v-if="thumbnailUrl">
                        <component-image
                            :url="thumbnailUrl"
                            :alt="venueName"
                            :full-height="true"
                        ></component-image>
                    </template>
                    <template v-else>
                        <v-icon name="image"/>
                    </template>
                </div>
            </div>
            <div class="column">
                <div class="venue__list_grid_item_content">
                    <h2 class="venue__list_grid_item_content_title">{{venueName}}</h2>
                    <div class="venue__list_grid_item_content_details">
                        <div class="venue__list_grid_item_content_details_rooms">
                            <div class="columns is-vcentered is-variable is-2">
                                <div class="column is-narrow">
                                    <v-icon name="home"/>
                                </div>
                                <div class="column">
                                    {{venueRoomsCount}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="venue__list_grid_item_content_status">
                        <component-status :status="venueStatus"/>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  components: { ComponentImage, ComponentStatus },
  name: 'venue-list-grid-item',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    thumbnailUrl: function () {
      if (this.item.files.length) {
        return `${api.files}/file/${this.item.files[0].fileId}`
      }
      return false
    },
    venueId: function () {
      return this.item.id
    },
    venueName: function () {
      return this.item.name
    },
    venueStatus: function () {
      return this.item.status
    },
    venueRoomsCount: function () {
      if (this.item.rooms) {
        return this.item.rooms.length === 1 ? `${this.item.rooms.length} ${this.$t('ebs.venues.list.return.room')}` : `${this.item.rooms.length} ${this.$t('ebs.venues.list.return.rooms')}`
      }
      return false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venuelistgriditem";
</style>
